import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FC3F1D\" d=\"M12 .387c6.42 0 11.626 5.206 11.626 11.626S18.42 23.639 12 23.639.374 18.433.374 12.013 5.579.387 12 .387\"></path><path fill=\"#fff\" d=\"M13.614 18.974h2.43V5.025h-3.535C8.956 5.022 7.087 6.85 7.087 9.54c0 2.148 1.025 3.411 2.851 4.716l-3.17 4.716h2.63l3.53-5.28-1.224-.821c-1.485-1.002-2.207-1.785-2.207-3.473 0-1.485 1.044-2.49 3.032-2.49h1.082z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }